<template>
  <div class="digitize-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner">
      <div class="content">
        <h1>产业数字化建设</h1>
        <p>通过人工智能、物联网、大数据等技术重构业务流程，提升产业效率与创新能力。</p>
        <div class="actions">
          <el-button class="btn-yellow" type="primary">立即体验</el-button>
          <el-button class="btn-dark" type="primary">&gt;</el-button>
        </div>
      </div>
    </div>

    <!-- 服务卡片部分 -->
    <div class="service-cards">
      <div class="service-row">
        <!-- 卡片1 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://echance.oss-cn-beijing.aliyuncs.com/digitize-bg2.png" alt="数字现场监控">
          </div>
          <div class="card-content">
            <h2>数字现场监控</h2>
            <p class="description">基础设施生命周期管理平台，延长设施使用寿命，加强质量和安全性监测。通过数字孪生技术增强运维效率超1.5倍。</p>
            <div class="feature-tags">
              <div class="tag">
                <span class="tag-name">运用场景</span>
                <span class="tag-value">智能工厂</span>
              </div>
              <div class="tag">
                <span class="tag-name">增值服务</span>
                <span class="tag-value">定制化开发</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 卡片2 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://echance.oss-cn-beijing.aliyuncs.com/digitize-bg3.png" alt="人机协同工坊">
          </div>
          <div class="card-content">
            <h2>人机协同工坊</h2>
            <p class="description">将先进的机器人工作平台（通过自动化技术增强）与工人基于丰富经验的创造力相结合，提高工作场所的效率与生产力。</p>
            <div class="feature-tags">
              <div class="tag">
                <span class="tag-name">运用场景</span>
                <span class="tag-value">智能制造</span>
              </div>
              <div class="tag">
                <span class="tag-name">增值服务</span>
                <span class="tag-value">产业规划</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="service-row">
        <!-- 卡片3 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://echance.oss-cn-beijing.aliyuncs.com/digitize-bg4.png" alt="数据资产户口">
          </div>
          <div class="card-content">
            <h2>数据资产户口</h2>
            <p class="description">为企业建立数据资产户口，实现数据资产化、数字资产证券化，进一步推动企业数字资产增值（30%-40%）。</p>
            <div class="feature-tags">
              <div class="tag">
                <span class="tag-name">运用场景</span>
                <span class="tag-value">客户分析</span>
              </div>
              <div class="tag">
                <span class="tag-name">增值服务</span>
                <span class="tag-value">效能优化</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 卡片4 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://echance.oss-cn-beijing.aliyuncs.com/digitize-bg5.png" alt="量小场景用环">
          </div>
          <div class="card-content">
            <h2>量小场景用环</h2>
            <p class="description">使用小型物联网传感器连接设备（+30万台/年）和金属物品，实现数据的自动化采集，减少人工成本。</p>
            <div class="feature-tags">
              <div class="tag">
                <span class="tag-name">运用场景</span>
                <span class="tag-value">数据采集与分析</span>
              </div>
              <div class="tag">
                <span class="tag-name">增值服务</span>
                <span class="tag-value">场景化应用</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 服务咨询部分 -->
    <div class="section-contact">
      <div class="contact-content">
        <h2>开启专属服务<br>获取更大价值</h2>
        <el-form class="contact-form" :model="contactForm" :rules="contactRules" ref="contactForm">
          <el-input v-model="contactForm.name" placeholder="您的姓名"></el-input>
          <el-input v-model="contactForm.mobile" placeholder="手机号码"></el-input>
          <div class="actions">
            <el-button class="btn-yellow" type="primary" @click="submitContactForm">Services</el-button>
            <el-button class="btn-dark" type="primary">&gt;</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { saveUserRequirementApi } from '@/api/index';

export default {
  name: 'digitizePage',
  data() {
    return {
      contactForm: {
        name: '',
        mobile: '',
        companyName: '测试公司名称',
        demandType: '1' // 数字化建设服务类型
      },
      contactRules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitContactForm() {
      // 判断姓名和手机号是否为空
      if (!this.contactForm.name || this.contactForm.name.trim() === '') {
        this.$message.error('请输入您的姓名');
        return;
      }
      if (!this.contactForm.mobile || this.contactForm.mobile.trim() === '') {
        this.$message.error('请输入手机号码');
        return;
      }
      
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          saveUserRequirementApi(this.contactForm).then(res => {
            this.$message.success('提交成功');
            this.contactForm.name = '';
            this.contactForm.mobile = '';
          }).catch(err => {
            this.$message.error('提交失败，请稍后重试');
            console.error(err);
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.digitize-page {
  width: 100%;
  background-color: #fff;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 1080px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/digitize-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  color: #fff;

  .content {
    width: 1200px;
    margin: 0 auto;
    padding-top: 345px;

    h1 {
      font-weight: bold;
      font-size: 78px;
      line-height: 92px;
      margin-bottom: 30px;
    }

    p {
      font-size: 17px;
      font-weight: bold;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      line-height: 25px;
      margin-bottom: 70px;
      max-width: 700px;
    }

    .actions {
      display: flex;

      .btn-yellow {
        background-color: #ffc107;
        border-color: #ffc107;
        color: #0F0FB1;
        width: 150px;
        height: 50px;
        font-size: 20px;
        font-weight: bold;
        line-height: 22px;
      }
      
      .btn-dark {
        background-color: #002366;
        border-color: #002366;
        color: #fff;
        width: 50px;
        height: 50px;
        margin-left: -5px;
      }
    }
  }
}

// 服务卡片区域
.service-cards {
  width: 1200px;
  margin: 80px auto;
}

.service-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
}

.service-card {
  width: 570px;
  background: #FFFFFF;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;

  .card-image {
    width: 100%;
    height: 280px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .card-content {
    padding: 30px;

    h2 {
      font-weight: bold;
      font-size: 32px;
      color: #19456B;
      line-height: 42px;
      margin-bottom: 15px;
    }

    .description {
      font-size: 17px;
      color: #666;
      line-height: 25px;
      margin-bottom: 20px;
    }

    .feature-tags {
      display: flex;
      flex-wrap: wrap;

      .tag {
        margin-right: 30px;
        margin-bottom: 10px;
        
        .tag-name {
          font-size: 16px;
          color: #999;
          margin-right: 10px;
        }
        
        .tag-value {
          font-size: 16px;
          color: #333;
          font-weight: bold;
        }
      }
    }
  }
}

// 服务咨询部分
.section-contact {
  margin: 0 auto 100px;
  width: 1200px;
  height: 340px;
  box-sizing: border-box;
  padding: 40px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/bg-contact.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;

  .contact-content {
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    h2 {
      font-weight: bold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 52px;
    }

    .contact-form {
      display: block;

      .el-input {
        width: 350px;
        display: block;
        margin-bottom: 25px;

        ::v-deep .el-input__inner {
          background-color: transparent;
          border: none;
          border-bottom: 2px solid rgba(255, 255, 255, 0.5);
          border-radius: 0;
          padding-left: 0;
          height: 50px;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 24px;

          &:focus {
            border-bottom-color: #fff;
          }

          &::placeholder {
            color: #ccc;
            font-size: 24px;
          }
        }
      }

      .actions {
        display: flex;

        .btn-yellow {
          background-color: #ffc107;
          border-color: #ffc107;
          color: #0F0FB1;
          width: 150px;
          height: 50px;
          font-size: 20px;
          font-weight: bold;
          line-height: 22px;
        }

        .btn-dark {
          background-color: #002366;
          border-color: #002366;
          color: #fff;
          width: 50px;
          height: 50px;
          margin-left: -5px;
        }
      }
    }
  }
}
</style>